import { type App, computed, nextTick, onMounted, reactive, ref } from 'vue'

export const breakpoints = [
  { name: 'mobile', width: 0, query: '(max-width: 767px)' },
  { name: 'tablet', width: 768, query: '(min-width: 768px) and (max-width:1023px)' },
  { name: 'desktop', width: 1024, query: '(min-width: 1024px) and (max-width:1365px)' },
  { name: 'l-desktop', width: 1366, query: '(min-width: 1366px) and (max-width:1919px)' },
  { name: 'xl-desktop', width: 1920, query: '(min-width: 1920px)' },
]

function getActiveBreakpoint() {
  if (typeof window !== 'undefined') {
    for (let i = 0; i < breakpoints.length; i += 1) {
      const bp = breakpoints[i]
      const match = window.matchMedia(bp.query)
      if (match.matches) {
        return bp.name
      }
    }
  }

  return 'mobile'
}

const data = reactive({
  breakpoint: getActiveBreakpoint(),
})

const install = function (app: App) {

  let mounted = false

  app.mixin({
    computed: {
      $mq() {
        return data.breakpoint
      },
    },
    mounted() {
      if (typeof window !== 'undefined' && !mounted) {
        mounted = true
        // Add a media query listener for each breakpoint
        breakpoints.forEach((breakpoint) => {
          const match = window.matchMedia(breakpoint.query)

          const trigger = (e) => {
            if (e.matches && data.breakpoint !== breakpoint.name) {
              data.breakpoint = breakpoint.name
            }
          }

          if (typeof match.addEventListener === 'function') {
            match.addEventListener('change', trigger)
          } else if (match.addListener) {
            match.addListener(trigger)
          }
        })
      }
    },
    methods: {
      $mqSync() {
        return getActiveBreakpoint()
      },
      $checkMQ() {
        if (data.breakpoint === 'mobile'
          || typeof window === 'undefined'
          || (this.$route && window.__INITIAL_STATE__ && this.$route.path !== window.__INITIAL_STATE__.route.path)) {
          return
        }
        data.breakpoint = ''
        nextTick(() => data.breakpoint = getActiveBreakpoint())
      },
    },
  })
}

export function useMQ() {
  const isMounted = ref(false)

  onMounted(() => {
    isMounted.value = true
  })

  const mq = computed(() => {
    if (!isMounted.value) return 'mobile' // SSR fallback
    
    return data?.breakpoint || 'mobile'
  })

  return mq
}

export default { install }
